import { Component, ChangeDetectionStrategy } from '@angular/core';

/**
 * The Google app's home screen chrome above the Discover feed — account avatar,
 * wordmark, search pill. Pinned, so consumers project it into the mobile
 * frame's `frameTop` slot.
 */
@Component({
    selector: 'app-discover-mobile-header',
    imports: [],
    templateUrl: './discover-mobile-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './discover-mobile-header.component.scss'
})
export class DiscoverMobileHeaderComponent {}
